export enum SearchStyles {
    Checkbox = 'checkbox',
    CheckboxGroup = 'checkboxGroup',
    ImmediateAutocomplete = 'immediateAutocomplete',
    SingleCheck = 'singleCheck',
    SingleCheckWithCustomValues = 'singleCheckWithCustomValues',
    Slider = 'slider',
}